import React from 'react'
import { Table } from 'antd'
import { observer } from 'mobx-react-lite'
import { ManagersStore } from '../../store/managers.store'
import { ManagerListColumns } from './manager-list.columns'

export const ManagerListFeature = observer(() => (
  <Table rowKey="id" columns={ManagerListColumns} dataSource={ManagersStore.managersList} />
))
